import React from 'react';
import PropTypes from 'prop-types';
// import 'bootstrap/dist/css/bootstrap.min.css';

function Avancar2({ ative, isButtonDisabled }) {
  const handleAvancar = () => {
    const setAtive = ative[1];
    const setIsButtonDisabled = isButtonDisabled[1];
    setAtive(ative[0] + 1);
    setIsButtonDisabled(true);
  };

  return (
    <footer className="step-footer" style={{ width: ative[0] === 1 ? '100%' : '' }}>
      <button type="submit" style={{ width: ative[0] === 1 ? '100%' : '191px' }} className="btn btn-primary avancar2" disabled={isButtonDisabled[0]} onClick={handleAvancar}>AVANÇAR</button>
    </footer>
  );
}

export default Avancar2;

Avancar2.propTypes = {
  ative: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.func])).isRequired,
  isButtonDisabled:
  PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.func])).isRequired,
};
